// extracted by mini-css-extract-plugin
export default {"divider":"LvhDW___Divider-module__divider"};